import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ButtonPrev from "../ui/ButtonPrev";
import ButtonNext from "../ui/ButtonNext";
import items from "../utils/PhotoGalleryData";
import { useTranslation } from "react-i18next";

const Carousel = () => {
  const contentRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const scrollToSection = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };
    scrollToSection();
  }, [location]);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  const generateItems = () => {
    const itemsToShow = [];
    for (let i = currentIndex - 1; i < currentIndex + 2; i++) {
      const index = (i + items.length) % items.length;
      const isActive = i === currentIndex;

      itemsToShow.push(
        <div
          key={index}
          className={`relative flex justify-center items-center flex-shrink-0 lg:w-[23vw] md:w-[19vw] sm:w-[50vw] xs:w-[50vw] xxs:w-[55vw] ${
            isActive
              ? "scale-100 z-10 opacity-100"
              : "hidden md:scale-90 md:z-5 md:opacity-100 md:flex"
          } aspect-[1/1] rounded-lg overflow-visible shadow-[0_0px_30px_rgba(0,0,0,0.7)] transition-all duration-500 ease-in-out`}
        >
          <img
            src={items[index].src}
            alt={items[index].label}
            className="w-full h-full object-cover rounded-lg"
          />
          <h4 className="absolute bottom-2 left-2 text-white 2xl:text-2xl xl:text-xl lg:text-base md:text-sm sm:text-xl xs:text-lg xxs:text-sm font-light uppercase text-left leading-tight">
            <span
              className="inline-block xl:px-5 xl:py-3 lg:px-4 lg:py-2 md:px-3 md:py-1 sm:px-4 sm:py-2 xs:px-2 xs:py-1 xxs:px-1 xxs:py-1"
              style={{
                background: items[index].gradient,
                display: "inline-block",
                maxWidth: "max-content",
              }}
            >
              {t(items[index].firstTitle)}
            </span>
            <span
              className="block xl:px-5 xl:py-3 lg:px-4 lg:py-2 md:px-3 md:py-1 sm:px-4 sm:py-2 xs:px-2 xs:py-1 xxs:px-1 xxs:py-1"
              style={{
                background: items[index].gradient,
                maxWidth: "max-content",
              }}
            >
              {t(items[index].secoundTitle)}
            </span>
          </h4>
        </div>
      );
    }
    return itemsToShow;
  };

  return (
    <section id="gallery" ref={contentRef} className="text-center w-full pt-28">
      <div className="text-center">
        <h2 className="text-5xl xl:text-5xl xxs:text-4xl font-bold text-green-800 py-6">
          {t("PhotoGallery.galleryTitle")}
        </h2>
      </div>
      <div className="relative w-full h-fit-content flex justify-center items-center pt-28 mb-10">
        {/* Previous Button */}
        <ButtonPrev
          onClick={prevSlide}
          aria-label="Previous Slide"
          className="absolute xs:left-[4%] lg:ml-18 xs:ml-12 ml-3 xxs:ml-0 xxs:left-[2%] w-10 h-10 bg-[#14532D] text-4xl text-white rounded-full shadow-2xl hover:bg-[#0c4020] pr-[3px] flex items-center justify-center"
        />
        {/* Carousel Items */}
        <div className="relative flex justify-center items-center gap-[2vw] transition-transform duration-500 ease-in-out">
          {generateItems()}
        </div>
        {/* Next Button */}
        <ButtonNext
          onClick={nextSlide}
          aria-label="Next Slide"
          className="absolute xs:right-[4%] lg:mr-18 xs:mr-12 mr-3 xxs:mr-0 xxs:right-[2%] w-10 h-10 bg-[#14532D] text-4xl text-white rounded-full shadow-2xl hover:bg-[#0c4020] pl-[3px] flex items-center justify-center"
        />
      </div>
    </section>
  );
};

export default Carousel;
